<template>
    <header>
        <nav class="navbar navbar-expand-lg bg-body-tertiary">
            <div class="container">
                <a class="navbar-brand" href="/">
                    <img class="bi me-2" width="32" height="32" role="img" src="./../favicon.webp" alt="buffer logo"/>
                    Buffer stats
                </a>
            </div>
        </nav>
    </header>
    <main class="container-fluid">
        <BTable
            v-if="storages"
            striped
            hover
            :items="storages"
            :fields="fields"
        >
            <template #cell(name)="row">
                <span @click="showDetails(row)" class="activeElement">
                    {{ row.item.name }}
                </span>
            </template>
            <template #cell(size)="row">
                {{ row.item.size }}
            </template>
            <template #cell(example)="row">
                <a :href="row.item.example" target="_blank">Example link</a>
            </template>
            <template #cell(lastMinute)="row">
                <a :href="row.item.lastMinuteUrl" target="_blank"> {{ row.item.lastMinutePeriod}}</a>
            </template>
            <template #row-details="row">
                <BCard>
                    <BTable
                        :items="row.item.details?.rows"
                        :fields="fieldsDetails"
                    >
                        <template #cell(id)="detailsRow">
                            <span @click="showRowDetails(row, detailsRow)" class="activeElement">
                                {{ detailsRow.item.id }}
                            </span>
                        </template>
                        <template #row-details="detailsRow">
                            <BCard>
                                <BTable
                                    v-if="storages"
                                    striped
                                    hover
                                    :items="detailsRow.item.details || []"
                                    :fields="Object.keys(detailsRow.item.details[0]).map((k: string) => ({ key: k, label: k }))"
                                />
                            </BCard>
                        </template>
                    </BTable>
                </BCard>
            </template>
        </BTable>
    </main>
</template>

<script setup lang="ts">
import { fetchJson } from "../utils/fetch"
import { ref, onMounted } from "vue"
import { BCard, BTable } from "bootstrap-vue-next"

interface detailsRow {
    id: string,
    details?: string,
}
interface Storage {
    name: string
    size: number
    example?: string
    lastMinuteUrl: string
    lastMinutePeriod: string
    details?: {
        rows: detailsRow[]
    }
}

const storages = ref<Storage[]>([])

const fields = [
    { key: "name", label: "Storage" },
    { key: "size", label: "Size" },
    { key: "example", label: "Example" },
    { key: "lastMinute", label: "Last 1 minute" },
]

const fieldsDetails = [
    { key: "id", label: "Id" },
    { key: "updatedAt", label: "Updated at" },
]

async function refresh() {
    storages.value = await fetchJson("/front/storages/list")
}

async function showDetails (row: { index: number, detailsShowing: boolean, toggleDetails: () => void, item: Storage }) {
    if (!row.detailsShowing) {
        storages.value[row.index].details = await fetchJson("/front/storages/details", { name: row.item.name })
    }
    row.toggleDetails()
}

async function showRowDetails (row: { index: number, item: Storage }, detailsRow: { index: number, detailsShowing: boolean, toggleDetails: () => void, item: { id: string } }) {
    if (!detailsRow.detailsShowing && storages.value[row.index].details !== undefined) {
        storages.value[row.index].details.rows[detailsRow.index].details = await fetchJson("/front/storages/rowDetails", { name: row.item.name, id: detailsRow.item.id })
    }
    detailsRow.toggleDetails()
}

// Lifecycle hooks
onMounted(async () => {
    await refresh()
})
</script>
